import React, { useEffect } from 'react';
import Message from 'legacy-src/utility/Message';
import Button from 'chameleon/ui-stack/ui/base/button';
import { preloadMathJaxWithLearnosity } from 'chameleon/src/utility/utils';
import './EditScoring.scss';
import './CodeMirror.scss';

import 'codemirror/mode/xml/xml';

import { useScoring } from './ScoringProvider';

import EditScoringSectionComponent from './EditScoringSectionComponent';

const testScoringSection = `Add one or more scoring sections that clearly state the qualities that need to be displayed
in a student's response to demonstrate proficient performance.`;

const EditScoring = ({ showValidation, validations, innerErrors }) => {
  const [scoreState, dispatch] = useScoring();

  useEffect(() => {
    /**
     * Potentially required by Prose equation embeds inside the
     * EditScoringSectionComponent components.
     */
    preloadMathJaxWithLearnosity();
  }, []);

  const handleAddScoringSection = () => {
    dispatch({ type: 'addScoringSection' });
  };

  const handleUpdateScoringSectionTitle = (sectionTitle, index) => {
    dispatch({
      type: 'updateScoringSectionTitle',
      payload: { sectionTitle, index },
    });
  };

  const handleUpdateScoringSectionInstructions = (
    scoringInstructions,
    index,
  ) => {
    dispatch({
      type: 'updateScoringSectionInstructions',
      payload: { scoringInstructions, index },
    });
  };

  const handleRemoveScoringSection = (index) => {
    dispatch({ type: 'removeScoringSection', payload: { index } });
  };

  const handleMoveScoringSectionUp = (index) => {
    dispatch({ type: 'moveScoringSectionUp', payload: { index } });
  };

  const handleMoveScoringSectionDown = (index) => {
    dispatch({ type: 'moveScoringSectionDown', payload: { index } });
  };

  return (
    <div className="ScoringFreeResponse__wrapper">
      <div className="ScoreCategoryEditor__wrapper">
        <Message>{testScoringSection}</Message>

        {showValidation && validations.scoringSectionErrors > 0 && (
          <Message className="--error">
            In order to publish a question, you must complete at least one{' '}
            <strong>Scoring Section</strong> below.
          </Message>
        )}

        {scoreState.scoreState.map((scoringSection, index) => (
          <EditScoringSectionComponent
            key={`${index}_scoring_section`}
            sectionIndex={index}
            innerErrors={innerErrors}
            showValidation={showValidation}
            sectionTitle={scoringSection.sectionTitle}
            scoringInstructions={scoringSection.scoringInstructions}
            scoringFeedback={scoringSection.scoringFeedback}
            handleUpdateScoringSectionTitle={handleUpdateScoringSectionTitle}
            handleUpdateScoringSectionInstructions={
              handleUpdateScoringSectionInstructions
            }
            handleRemoveScoringSection={handleRemoveScoringSection}
            handleMoveScoringSectionUp={handleMoveScoringSectionUp}
            handleMoveScoringSectionDown={handleMoveScoringSectionDown}
            showActionButtons={scoreState.scoreState.length > 1}
          />
        ))}
        <div className="mb-20">
          <Button
            isOutline
            className="w-full ScoreCategoryEditor__add_score_section"
            onClick={handleAddScoringSection}
          >
            Add Scoring Section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditScoring;
